import { useEffect } from "react"
import { useQuit } from "../../api/hooks/useQuit"

const QuitPage = () => {
  const { refetch: quit } = useQuit()

  useEffect(() => {
    quit()
  }, [])

  return (
    <> </>
  )
}

export default QuitPage
